import { API_BASE_URL } from "../../config/constants";
import { getRequest, postRequest } from "../API";


/*********************************************************
* Function Name : POst user feedback
* Description   : user can give star on experince of wesite
* By            : Md Rashid ALi
* Date          : 06-February-2025
*********************************************************/
export const feedbackReview = async (options) => {
    try {
        const params = {
            url: `${API_BASE_URL}submission/review-site`,
            postData: options
        }
        const res = await postRequest(params);
        // console.log( "generalDatadfsdf: ", res);
        
        if (res.status === true || res.status === 200) {
            return { status: true, result: res?.data?.response?.result };
        } else {
            return { status: false, message: res?.response?.data?.statusMessage }
        }
    } catch (error) {
        console.log("Error", error);
        return { status: false, message: "Under Maintenance, Please try after some time." }
    }
}//end